import React from 'react';

import { SimpleTag } from '@atlaskit/tag';

import { BugsSummaryTextStyled } from './ReportColumn.styled';

type Props = {
  bugsSummary: { pendingPercent: number };
};

export default function OpenPercent({ bugsSummary }: Props): JSX.Element {
  const text = `${bugsSummary.pendingPercent}% open`;

  if (bugsSummary.pendingPercent >= 60) {
    return <SimpleTag text={text} color='redLight' />;
  }

  return <BugsSummaryTextStyled>{text}</BugsSummaryTextStyled>;
}
